var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, useTheme, useMediaQuery } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import Card from '@mui/material/Card';
export var DefaultCard = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Dados' : _b, children = _a.children, subTitle = _a.subTitle, style = _a.style;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (_jsx(Card, __assign({ style: __assign({}, style) }, { children: _jsxs(Grid, __assign({ container: true, spacing: isMobile ? 1 : 2 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [title &&
                            (_jsx(Typography, __assign({ sx: { wordBreak: 'break-word' }, variant: 'h5', gutterBottom: true }, { children: title }))), subTitle &&
                            (_jsx(Typography, __assign({ sx: { wordBreak: 'break-word' }, variant: 'subtitle1', align: "center", gutterBottom: true }, { children: subTitle })))] })), children] })) })));
};
